import { BasicQueryStringUtils } from '../query_string_utils';
import { LocationLike, StringMap } from '../types';

export class NoHashQueryStringUtils extends BasicQueryStringUtils {
    parse(input: LocationLike, useHash?: boolean): StringMap {
        return super.parse(input, false /* never use hash */);
    }
}
